import * as Tab from '@radix-ui/react-tabs';
import styled, { css } from 'styled-components';
import { getPaletteColor } from '../utils';
import { Text } from '../Text/Text';
const getSizeStyles = (size, icon) => {
  switch (size) {
    case 'sm':
      return css(["font-size:12px;padding:12px;"]);
    case 'md':
      return css(["font-size:14px;padding:16px;", ""], icon && `padding-left: 8px;`);
  }
};
export const StyledText = /*#__PURE__*/styled(Text).withConfig({
  displayName: "Tabstyled__StyledText",
  componentId: "sc-1fad97d-0"
})(["", " font-family:Montserrat;"], props => getSizeStyles(props.size, props.icon));
export const TabTriggerButton = /*#__PURE__*/styled(Tab.Trigger).withConfig({
  displayName: "Tabstyled__TabTriggerButton",
  componentId: "sc-1fad97d-1"
})(["cursor:pointer;border:", ";width:", ";border-radius:12px 12px 0 0;color:", ";background-color:", ";&:hover{color:", ";background-color:", ";}&[data-state='active']{&:hover{background-color:", ";}&::after{margin:-4px 12px 0;content:'';display:block;height:4px;background-color:", ";border-radius:12px 12px 0 0;}&:hover{&::after{background-color:", ";}}}"], props => props.buttonBorder ? `1px solid ${getPaletteColor('border.light')(props)}` : 'none', props => props.dynamicTabWidth ? '100%' : 'auto', getPaletteColor('primary.base'), props => !props.isTransparent ? getPaletteColor('text.lightest')(props) : 'transparent', getPaletteColor('primary.dark'), props => !props.isTransparent ? getPaletteColor('background.base')(props) : 'transparent', props => !props.isTransparent ? getPaletteColor('primary.light')(props) : 'transparent', getPaletteColor('primary.base'), props => getPaletteColor('primary.dark')(props));
export const TabTriggerRadio = /*#__PURE__*/styled(Tab.Trigger).withConfig({
  displayName: "Tabstyled__TabTriggerRadio",
  componentId: "sc-1fad97d-2"
})(["cursor:pointer;}"]);
export const TabList = /*#__PURE__*/styled(Tab.List).withConfig({
  displayName: "Tabstyled__TabList",
  componentId: "sc-1fad97d-3"
})(["flex-direction:", ";"], props => props?.orientation === 'horizontal' ? 'row' : 'column');